import { z } from 'zod';

export const pagePreviewSchema = z.object({
  previewPageUrl: z.string().default('/preview'),
  enableAppTop: z.boolean().default(false),
  enableAppFooter: z.boolean().default(false)
});
